import { createContext, useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import Login from './Login';
import UserProfile from './UserProfile';
import Subscribe from '../Popups/Subscribe'; 
import { CloseButton, PopupDefault } from '../ReusableComponents/PopupDefault';
import { useAuth } from '../../contexts/AuthContext';

// Create context for managing auth modals
const AuthModalContext = createContext();

// Hook to use the auth modal context
export const useAuthModal = () => {
  const context = useContext(AuthModalContext);
  if (!context) {
    throw new Error('useAuthModal must be used within an AuthModalProvider');
  }
  return context;
};

// Provider component that manages modal state and renders portals
export const AuthModalProvider = ({ children }) => {
  const [showLogin, setShowLogin] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showSubscribe, setShowSubscribe] = useState(false);
  const [showLicenseUpgrade, setShowLicenseUpgrade] = useState(false);

  const { user, subscriptionActive, subscriptionLoading, hasActiveLicense, hadActiveLicense } = useAuth();

  const openLogin = () => {

    // Store current URL when opening login modal
    const currentPath = window.location.pathname + window.location.search + window.location.hash;

    if (currentPath !== '/' && currentPath !== '/#') {
      localStorage.setItem('redirectAfterLogin', currentPath);
    }

    setShowLogin(true);
  };


  const closeLogin = () => setShowLogin(false);
  const openProfile = () => {
    setShowProfile(true);
  };
  const closeProfile = () => setShowProfile(false);
  const openSubscribe = () => {
    console.trace();
    setShowSubscribe(true);
  };
  const closeSubscribe = () => {
    setShowSubscribe(false);
  };

  const openLicenseUpgrade = () => {
    setShowLicenseUpgrade(true);
  };
  const closeLicenseUpgrade = () => {
    setShowLicenseUpgrade(false);
  };

  const shouldShowSubscribeModal = showSubscribe && user && !subscriptionActive && !subscriptionLoading;
  const shouldShowLicenseUpgradeModal = showLicenseUpgrade && user && !subscriptionLoading;

  const value = {
    openLogin,
    closeLogin,
    openProfile,
    closeProfile,
    openSubscribe,
    closeSubscribe,
    openLicenseUpgrade,
    closeLicenseUpgrade,
    showLogin,
    showProfile,
    showSubscribe,
    showLicenseUpgrade
  };

  return (
    <AuthModalContext.Provider value={value}>
      {children}

      {/* Render modals using portals - they'll appear at the end of body */}
      {showLogin && createPortal(
        <Login onClose={closeLogin} />,
        document.body
      )}

      {showProfile && createPortal(
        <UserProfile onClose={closeProfile} />,
        document.body
      )}

      {/* Updated subscribe modal logic */}
      {shouldShowSubscribeModal && createPortal(
        <PopupDefault onClose={closeSubscribe}>
          <CloseButton onClose={closeSubscribe} />
          {/* <Subscribe hasActiveLicense={subscriptionActive} hadActiveLicense={hadActiveLicense} /> */}
          <Subscribe hasActiveLicense={hasActiveLicense} hadActiveLicense={hadActiveLicense} />
        </PopupDefault>,
        document.body
      )}

      {/* License upgrade modal */}
      {shouldShowLicenseUpgradeModal && createPortal(
        <PopupDefault onClose={closeLicenseUpgrade}>
          <CloseButton onClose={closeLicenseUpgrade} />
          {/* <Subscribe hasActiveLicense={subscriptionActive} hadActiveLicense={hadActiveLicense} /> */}
          <Subscribe hasActiveLicense={hasActiveLicense} hadActiveLicense={hadActiveLicense} />
        </PopupDefault>,
        document.body
      )}
    </AuthModalContext.Provider>
  );
};




